import { combineReducers } from 'redux'
import manageProjects from './routes/projects/reducers/manageProjects'
import manageProjectFilters from './routes/projects/reducers/manageProjectFilters'
import manageProjectCreation from './routes/projects/reducers/manageProjectCreation'
import manageResourcePosts from './routes/resource-posts/reducers/manageResourcePosts'

import manageResourcePostCreation from './routes/resource-posts_new/reducers/manageResourcePostCreation'
import manageLogin from './routes/login/reducers/manageLogin'
import manageNotifications from './routes/notifications/reducers/manageNotifications'
import manageHours from './routes/workload/reducers/manageHours'
import manageAnalytics from './routes/analytics/reducers/manageAnalytics'
import manageProposals from './routes/proposals/reducers/manageProposals'
import manageProposalCreation from './routes/proposals/reducers/manageProposalCreation'
import manageProposalFilters from './routes/proposals/reducers/manageProposalFilters'

import managePublications from './routes/publications/reducers/managePublications'
import manageSAPResources from './routes/sap-resources/reducers/manageSAPResources'

const rootReducer = combineReducers({
  manageProjects, manageResourcePosts, manageLogin,
  manageProjectFilters, manageProjectCreation, manageHours, manageResourcePostCreation,
  manageAnalytics, manageNotifications, manageProposals, manageProposalCreation, manageProposalFilters, managePublications, manageSAPResources,
})

export default rootReducer



// WEBPACK FOOTER //
// ./src/rootReducer.js